import rawTourmalineItems from './tourmaline-items.json';
import rawSnakeItems from './snake-items.json';
import rawFluoringItems from './fluoring-items.json';
import rawChineseZodiacItems from './chinese-zodiac-items.json';

export type JewelleryCollectionId = 'tourmaline' | 'snake' | 'fluoring' | 'chinese_zodiacs';

export type JewelleryLanguage = 'en' | 'de' | 'fr' | 'zh';

export type JewelleryItemTranslationEntry = {
    name: string;
    description: string;
};

export type JewelleryItemTranslations = Partial<Record<JewelleryLanguage, JewelleryItemTranslationEntry>>;

export interface JewelleryItemData {
    id: string;
    collectionId: JewelleryCollectionId;
    image: string;
    price: string;
    sku?: string;
    carouselImages?: string[];
    translations?: JewelleryItemTranslations;
}

const tourmalineItems = rawTourmalineItems as JewelleryItemData[];
const snakeItems = rawSnakeItems as JewelleryItemData[];
const fluoringItems = rawFluoringItems as JewelleryItemData[];
const chineseZodiacItems = rawChineseZodiacItems as JewelleryItemData[];

const collectionMap: Record<JewelleryCollectionId, JewelleryItemData[]> = {
    tourmaline: tourmalineItems,
    snake: snakeItems,
    fluoring: fluoringItems,
    chinese_zodiacs: chineseZodiacItems
};

export function getJewelleryCollectionItems(collectionId: JewelleryCollectionId): JewelleryItemData[] {
    return collectionMap[collectionId] || [];
}

export function getJewelleryItem(collectionId: JewelleryCollectionId, itemId: string): JewelleryItemData | undefined {
    return getJewelleryCollectionItems(collectionId).find(item => item.id === itemId);
}
